import React from "react";
import { CheckIcon } from "lucide-react";
import { audience, learnings } from "../data/content";
import { images } from "../data/offer";
import { CtaButton } from "./CtaButton";
export function Transformation() {
  return <section className="bg-mint py-20 md:py-28" aria-labelledby="solution-title" style={{
    backgroundColor: "#1C3A55",
    backgroundImage: "none"
  }} data-id="element-238" data-mp="ml379hfj2jal">
      <div className="mx-auto max-w-6xl px-5 md:px-8" style={{
      backgroundColor: "#FBF7EE",
      backgroundImage: "none"
    }} data-id="element-239" data-mp="wkbttp82cvmx">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-240" data-mp="11ide2dh870zz">
          <div className="relative order-2 lg:order-1" data-id="element-241" data-mp="169ln38en8kcm">
            <img src={images.owner} width={928} height={1152} loading="lazy" decoding="async" alt="Emprendedora de limpieza sonriendo con sus productos en una casa luminosa" className="aspect-[4/5] w-full rounded-[2rem] object-cover" data-id="element-242" data-mp="16c85k332ok9m" />
          </div>
          <div className="order-1 lg:order-2" data-id="element-243" data-mp="1k93gy26sqnsu">
            <h2 id="solution-title" className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.75rem]" data-id="element-244" data-mp="1k7sce05j1c0o">
              No necesitás improvisar. Necesitás un método.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-245" data-mp="1791p0ajfgn9p">
              Por eso creamos <strong className="text-ink" data-id="element-246" data-mp="135lsrfb9soxj">De cero a tu empresa de limpieza</strong>: una guía
              digital práctica, diseñada para acompañarte desde la idea inicial hasta la organización de tus
              servicios y la búsqueda de clientes.
            </p>
            <h3 className="mt-9 text-sm font-bold text-ink" data-id="element-247" data-mp="1qvzb2e41z9ex">Vas a aprender a:</h3>
            <ol className="mt-4 space-y-4" data-id="element-248" data-mp="1m3o9l6tnzfk9">
              {learnings.map((item, i) => <li key={item} className="flex items-start gap-4" data-id="element-249" data-mp="1m1v5nzafr9fy" data-mpi={i}>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ink font-display text-sm font-semibold text-cream" data-id="element-250" data-mp="1h4lf2gbb8rqj">
                    {i + 1}
                  </span>
                  <span className="pt-1 font-medium text-ink" data-id="element-251" data-mp="29shcjn8penod">{item}</span>
                </li>)}
            </ol>
          </div>
        </div>

        <div className="mt-20 grid overflow-hidden rounded-[2rem] bg-white lg:grid-cols-[1.1fr_1fr]" data-id="element-252" data-mp="2xoud3zlivcej">
          <div className="p-8 md:p-12" data-id="element-253" data-mp="2jxz48nb0wvay">
            <h2 className="font-display text-2xl font-semibold leading-tight text-ink md:text-4xl" data-id="element-254" data-mp="2jx7hm1zem7wt">
              Este producto es para vos si…
            </h2>
            <ul className="mt-7 space-y-4" data-id="element-255" data-mp="29z03rs0ew5z1">
              {audience.map(item => <li key={item} className="flex items-start gap-3" data-id="element-256" data-mp="2a1w0jd0iwolw">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-257" data-mp="2f07arouqd14n" />
                  <span className="leading-relaxed text-ink" data-id="element-258" data-mp="210o3szdnnvtx">{item}</span>
                </li>)}
            </ul>
            <p className="mt-7 font-semibold text-muted" data-id="element-259" data-mp="252j35yc0zz52">
              No necesitás tener una empresa armada para empezar a aprender.
            </p>
            <div className="mt-8" data-id="element-260" data-mp="39d58wsdb5jh">
              <CtaButton size="md" data-id="element-261" data-mp="38acskfecv1g">Quiero mi guía</CtaButton>
            </div>
          </div>
          <img src={images.team} width={1264} height={848} loading="lazy" decoding="async" alt="Equipo de tres mujeres de una empresa de limpieza con delantales azules junto a su auto con productos" className="h-72 w-full object-cover sm:h-96 lg:h-full" data-id="element-262" data-mp="1nrnjcaz0a5eb" />
        </div>
      </div>
    </section>;
}